import { fetchSCS } from '@cube/utils/lib/scs-api';
import { serialize } from './utils';

export function fetchFromDailyMotionPlaylist({ startContentServiceOrigin, streamClient, dmPlaylist, limit, page }) {
	let queryParams = {};

	if (limit) queryParams.limit = limit;
	if (page) queryParams.page = page;

	return fetchSCS(`/dailymotion/playlist/${dmPlaylist}/${serialize(queryParams)}`, streamClient, startContentServiceOrigin);
}

export function fetchFromDailyMotionRelatedVideos({ startContentServiceOrigin, streamClient, article, limit, page }) {
	let queryParams = {};

	if (limit) queryParams.limit = limit;
	if (page) queryParams.page = page;

	return fetchSCS(`/dailymotion/relatedvideos/${article}/${serialize(queryParams)}`, streamClient, startContentServiceOrigin);
}

export function fetchTitle(feed, streamClient, startContentServiceOrigin) {
	return fetchSCS(`/feeds/id/`+feed+'/', streamClient, startContentServiceOrigin);
}

export function fetchFirestoreDocument(firebaseConfig){
	const url = `https://firestore.googleapis.com/v1/projects/${firebaseConfig?.projectId}/databases/(default)/documents/${firebaseConfig?.collection}/${firebaseConfig?.docId}`;
	return fetch(url)
		.then((res) => {
			if (!res.ok) throw new Error('Failed to fetch Firestore document');
			return res.json();
		})
		.catch((error) => {
			console.error(`Error fetching Firestore document (${firebaseConfig?.collection}/${firebaseConfig?.docId}):`, error);
			return null;
		});
}

export function	parseFirestoreMap(fields) {
	const obj = {};
	for (const key in fields) {
		if (Object.prototype.hasOwnProperty.call(fields, key)) {
			const field = fields[key];
			if ('stringValue' in field) obj[key] = field.stringValue;
			else if ('booleanValue' in field) obj[key] = field.booleanValue;
			else if ('integerValue' in field) obj[key] = parseInt(field.integerValue, 10);
			else if ('doubleValue' in field) obj[key] = parseFloat(field.doubleValue);
			else if ('mapValue' in field) obj[key] = parseFirestoreMap(field.mapValue.fields);
			else if ('arrayValue' in field) {
				obj[key] = (field.arrayValue.values || []).map(v =>
					v.mapValue ? parseFirestoreMap(v.mapValue.fields) : Object.values(v)[0]
				);
			}
		}
	}
	return obj;
}

